export interface ISegmentsDMPTaxonomy {
  DMPSegmentID: string;
  DataProviderName: string;
  DataProviderID: string;
  HeirarchicalSegmentName: string;
}

export function parseDMPTaxonomyData(samsungDataStore: string): ISegmentsDMPTaxonomy[] {
  const dedupedDMPTaxonomySegments: ISegmentsDMPTaxonomy[] = [];
  const dataArray = samsungDataStore.split('\n');
  dataArray
    .filter((d: string) => d !== '')
    .forEach((d: string) => {
      const data = d.split('\t');
      const taxonomyData = {
        DMPSegmentID: data[0] || '',
        DataProviderName: data[1] || '',
        DataProviderID: data[2] || '',
        HeirarchicalSegmentName: data[3] || '',
      } as ISegmentsDMPTaxonomy;

      dedupedDMPTaxonomySegments.push(taxonomyData);
    });
  return dedupedDMPTaxonomySegments.sort((a: ISegmentsDMPTaxonomy, b: ISegmentsDMPTaxonomy) => {
    return (parseInt(a.DMPSegmentID, 10) || 0) - (parseInt(b.DMPSegmentID, 10) || 0);
  });
}

export function filterDMPTaxonomyDataBySearchText(
  segmentsDMPData: ISegmentsDMPTaxonomy[],
  searchText: string,
): ISegmentsDMPTaxonomy[] {
  const filteredDMPTaxonomyData: ISegmentsDMPTaxonomy[] = [];

  segmentsDMPData.forEach((data) => {
    if (
      data.DMPSegmentID.toLocaleLowerCase().includes(searchText) ||
      data.DataProviderID.toLocaleLowerCase().includes(searchText) ||
      data.DataProviderName.toLocaleLowerCase().includes(searchText) ||
      data.HeirarchicalSegmentName.toLocaleLowerCase().includes(searchText)
    ) {
      filteredDMPTaxonomyData.push(data);
    }
  });
  return filteredDMPTaxonomyData;
}
